import React from "react";
import Logo from "../assets/yivo_symbol_noBgColor.png";

const Blog = () => {
  return (
    <div className="bg-gray-900 text-gray-100">
      {/* Hero Section */}
      <section className="py-20 px-4 text-center">
        <div className="max-w-5xl mx-auto">
          <img src={Logo} alt="Yivo Logo" className="h-24 mx-auto mb-6" />
          <h1 className="text-4xl sm:text-5xl font-bold text-purple-400 mb-6">
            Yivo Dev Blog
          </h1>
          <p className="text-xl text-gray-300 leading-relaxed max-w-3xl mx-auto">
            Platform updates, dev notes, and the occasional keyboard scream.
            This is where new features, fixes, and failures get documented.
          </p>
        </div>
      </section>

      {/* Newsfeed-style Blog Posts */}
      <section className="bg-gray-800 py-12 px-4">
        <div className="max-w-3xl mx-auto space-y-10">
          {/* Post 3 */}
          <article className="bg-[#2b2b40] p-6 rounded-2xl border border-gray-700 shadow-md">
            <p className="text-sm text-gray-400 mb-2">June 30, 2025</p>
            <h2 className="text-2xl font-semibold text-purple-300 mb-3">
              Ransomware.live integration
            </h2>
            <p className="text-gray-200 leading-relaxed">
              This was a feature I knew I wanted to add from the start. I just wasn't sure the best way. 
              Ultimately, after experimenting with the idea of tracking across darkweb sources, I decided to use the ransomware.live API so I could focus efforts elsewhere. Check it out under the Insights module.
              </p>
          </article>
          {/* Post 2 */}
          <article className="bg-[#2b2b40] p-6 rounded-2xl border border-gray-700 shadow-md">
            <p className="text-sm text-gray-400 mb-2">June 25, 2025</p>
            <h2 className="text-2xl font-semibold text-purple-300 mb-3">
              Timestamp Parsing and Feed Updates
            </h2>
            <p className="text-gray-200 leading-relaxed">
              Spending a good amount of time working on the timestamp parsing for the feeds.
              It’s a bit of a mess right now, but I’m making progress. I had it going well but then made a few performance-related changes to the feed ingestion process and something got mixed up.
              </p>
            <p className="text-gray-200 leading-relaxed">
            A few of the MISP feeds are working but some of the freetext and CSV are not properly grabbing the timestamp field. Looking into it.
            </p>
          </article>
          <article className="bg-[#2b2b40] p-6 rounded-2xl border border-gray-700 shadow-md">
            <p className="text-sm text-gray-400 mb-2">June 10, 2025</p>
            <h2 className="text-2xl font-semibold text-purple-300 mb-3">
              🚀 First Post
            </h2>
            <p className="text-gray-200 leading-relaxed">
              Who knew these efforts would take time. I'm enjoying the learning aspect that comes
              with it though. I guess that's the process. Build a thing and create several new tasks while breaking other things.
                Rinse and repeat.</p>
            <p className="text-gray-200 leading-relaxed">
            I'm working through making sure the native feeds are parsing properly (they aren't). Or at least not all of them. I've got a couple million
            IOCs in the DB though so that's a decent start I guess. Need to work on the mailer for the contact form as well. Stay tuned.
            
            </p>
          </article>
        </div>
      </section>

      {/* Footer Note */}
      <section className="bg-[#f3f4f6] py-16 px-4 text-center">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl font-bold text-purple-600 mb-4">
            Updates Will Continue Until Morale Improves
          </h2>
          <p className="text-lg text-gray-700 leading-relaxed">
            This dev blog is the best place to track what’s changing inside
            Yivo. When in doubt, check here for patch notes, apologies, and the
            occasional dev meme.
          </p>
        </div>
      </section>
    </div>
  );
};

export default Blog;
